import { useStoreState, useStoreActions } from 'store/index'
import th from 'locales/sdoc/th'
import en from 'locales/sdoc/en'

const translations = { th, en }

export function useTranslation() {
	const language = useStoreState(s => s.appModel.language)
	const setLanguage = useStoreActions(a => a.appModel.setLanguage)

	const t = (key) => {
		const keys = key.split('.')
		let result = translations[language]
		for (const k of keys) {
			result = result?.[k]
		}
		return result ?? key
	}

	return { t, language, setLanguage }
}
